import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { doc, setDoc, getFirestore } from "firebase/firestore";

const VAPID_KEY = "BKTKTKmLClyTxPohUjKNp5S5O4_h_bOc5smkUYS2yUvuI8uKC4ySe7uLzT0ALCAw6cogQ4csBqAX2mewyhQZPiM";

// Call this after user logs in
export async function initPushNotifications(userId) {
  try {
    if (!("Notification" in window)) return;
    if (!("serviceWorker" in navigator)) return;

    const permission = await Notification.requestPermission();
    if (permission !== "granted") return;

    const messaging = getMessaging();
    const token = await getToken(messaging, { vapidKey: VAPID_KEY });

    if (token && userId) {
      const db = getFirestore();
      await setDoc(doc(db, "fcmTokens", userId), {
        token,
        userId,
        updatedAt: new Date().toISOString(),
        platform: "web",
      });
      console.log("FCM token saved:", token);
    }

    // Handle foreground messages
    onMessage(messaging, (payload) => {
      const { title, body } = payload.notification || {};
      if (title) {
        new Notification(title, {
          body: body || "",
          icon: "/logo192.png",
          badge: "/logo192.png",
          vibrate: [200, 100, 200],
        });
      }
    });

    return token;
  } catch (err) {
    console.log("Push notification setup failed:", err);
  }
}

// Send notification to a specific user (call from admin or trigger)
export async function sendPushToUser(toUserId, title, body) {
  try {
    const db = getFirestore();
    // Save notification to Firestore — your Cloud Function or admin panel reads this
    await setDoc(doc(db, "pushQueue", `${toUserId}_${Date.now()}`), {
      toUserId,
      title,
      body,
      createdAt: new Date().toISOString(),
      sent: false,
    });
  } catch {}
}
